module.exports = __webpack_public_path__ + "static/media/InspectionsGroup.c3df65db.svg";